import React from 'react'
import { Tab } from 'semantic-ui-react'
// import STSList from './STSList';
// import STSList from './STSList';
import STSList from './../../admin/_sts/STSList';
import ValidasiSTS from './../../admin/_sts/ValidasiSTS';

const panes = [
   { 
      menuItem: 'List STS', 
      render: () => <Tab.Pane attached={false}><STSList /></Tab.Pane> 
    },
    { 
      menuItem: 'Validasi STS', 
      render: () => <Tab.Pane attached={false}><ValidasiSTS /></Tab.Pane> 
    },
]

// const panes = [
//    { 
//       menuItem: 'Semua STS', 
//       render: () => <Tab.Pane attached={false}><STSList /></Tab.Pane> 
//     },
// ]

const STSIndex = () => (
  <Tab menu={{ pointing: true }} panes={panes} />
)

export default STSIndex;


// WEBPACK FOOTER //
// ./src/components/Content/views/verificator/_sts/STSIndex.js